module.exports = __webpack_public_path__ + "img/stars-4.5.04eb3e5.svg";